module.exports = __webpack_public_path__ + "img/sec1_box.fdb88dc1.jpg";